export default function DataComparison() {
  window.location.replace('https://utilities.odynn.com');
  return null;
}
